"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SttRadioButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
    disableRipple: true
  }, props));
}
var _default = SttRadioButton;
exports["default"] = _default;